import { render, staticRenderFns } from "./CurrentStepTitle.vue?vue&type=template&id=317838e8&lang=pug&"
import script from "./CurrentStepTitle.vue?vue&type=script&lang=ts&"
export * from "./CurrentStepTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports